import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Terminal, AlertOctagon } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (r.ok) nav("/dashboard");
    else setError(r.error);
  };

  return (
    <div className="min-h-[calc(100vh-60px)] grid md:grid-cols-2">
      <div className="hidden md:block relative" style={{
        backgroundImage: "url('https://images.unsplash.com/photo-1567360425618-1594206637d2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxyZWQlMjBnbGl0Y2glMjBhYnN0cmFjdCUyMGRhcmt8ZW58MHx8fHwxNzg1OTUxMTcyfDA&ixlib=rb-4.1.0&q=85')",
        backgroundSize: "cover", backgroundPosition: "center", opacity: 0.35,
      }}>
        <div className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(5,5,5,0.6), rgba(5,5,5,1))" }} />
        <div className="relative z-10 p-10 h-full flex flex-col justify-center items-start">
          <img
            src="/logo.png"
            alt="Red Team Solutions"
            data-testid="login-logo"
            className="w-80 mb-6 drop-shadow-[0_0_30px_rgba(255,42,42,0.35)]"
          />
          <p className="text-red-500 uppercase text-xs tracking-[0.4em]">// terminal_access</p>
          <h2 className="text-4xl text-red-500 uppercase tracking-tighter font-bold mt-3">Red<br/>Team<br/>Solutions</h2>
          <p className="text-neutral-400 mt-4 max-w-md text-sm">
            Reporta bugs con precisión quirúrgica. Sin excusas, sin descripciones vagas.
          </p>
        </div>
      </div>

      <div className="flex items-center justify-center p-8">
        <form data-testid="login-form" onSubmit={submit} className="w-full max-w-md term-panel-strong p-8">
          <div className="flex flex-col items-center mb-6 md:hidden">
            <img src="/logo.png" alt="Red Team Solutions" data-testid="login-logo-mobile" className="w-48 mb-2" />
          </div>
          <div className="flex items-center gap-2 text-red-500 text-xs uppercase tracking-[0.3em] mb-2">
            <Terminal size={14} /> <span className="blink-cursor">login</span>
          </div>
          <h1 className="text-3xl text-neutral-100 uppercase tracking-tighter font-bold mb-8">
            Acceso al<br/><span className="text-red-500">sistema</span>
          </h1>

          <label className="term-label">Email</label>
          <input data-testid="login-email-input" type="email" required
            value={email} onChange={(e) => setEmail(e.target.value)}
            className="term-input mb-4" placeholder="admin@bugtracker.com" autoComplete="email" />

          <label className="term-label">Contraseña</label>
          <input data-testid="login-password-input" type="password" required
            value={password} onChange={(e) => setPassword(e.target.value)}
            className="term-input mb-6" placeholder="********" autoComplete="current-password" />

          {error && (
            <div data-testid="login-error" className="flex items-start gap-2 text-red-500 text-xs uppercase tracking-widest mb-4 shake">
              <AlertOctagon size={14} className="mt-0.5" />
              <span className="glitch">{error}</span>
            </div>
          )}

          <button data-testid="login-submit-btn" type="submit" disabled={busy} className="term-btn w-full justify-center">
            {busy ? "> conectando..." : "> Ingresar"}
          </button>

          <div className="mt-6 text-xs text-neutral-500 uppercase tracking-[0.2em]">
            ¿Sin cuenta? <Link data-testid="login-goto-register" to="/register" className="text-red-500">Regístrate</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
